const { getElements } = window.BAO.Utils

export class ProductUpsells extends window.BAO.CustomElement() {
  connectedCallback () {
    /* eslint-disable-next-line no-undef */
    if (Shopify.designMode) return

    super.connectedCallback()

    this.renderProducts().then(() => {
      if (
        this.dataset.onloadVariantSize &&
        this.dataset.onloadVariantAvailable === 'false'
      ) {
        this.filterRenderedProducts(this.dataset.onloadVariantSize)
      }
    })
  }

  async renderProducts () {
    return fetch(
      `${window.Shopify.routes.root}recommendations/products?product_id=${this.productId}&section_id=product-upsells`,
    )
      .then((response) => response.text())
      .then((text) => {
        this.innerHTML = text
      })
      .catch((e) => {
        console.error(e)
      })
  }

  filterRenderedProducts (size, available) {
    if (available === true) {
      this.setAttribute('aria-hidden', true)
      return
    }

    const products = getElements('[data-product-upsell-el="product"]', {
      context: this,
    })
    let matchingProductCount = 0

    products.forEach((product) => {
      const productAvailabilityData = JSON.parse(
        product.dataset.sizeAvailability,
      )

      if (
        productAvailabilityData[size] === 'true' &&
        matchingProductCount < parseInt(this.limit, 10)
      ) {
        product.setAttribute('aria-hidden', false)
        matchingProductCount++
      } else {
        product.setAttribute('aria-hidden', true)
      }
    })

    this.setAttribute('aria-hidden', matchingProductCount === 0)
  }

  get productId () {
    return this.dataset.productId
  }

  get limit () {
    return this.dataset.limit
  }
}

if (!customElements.get('product-upsells')) {
  customElements.define('product-upsells', ProductUpsells)
}
